'use strict';exports.__esModule = true;
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _clearNumber = require('./clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _routerAdapter = require('./routerAdapter');
var _advancedFiltersSearchRequest = require('./advancedFiltersSearchRequest');var _advancedFiltersSearchRequest2 = _interopRequireDefault(_advancedFiltersSearchRequest);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var sendSearchRequest = function sendSearchRequest(fields, location) {var routeParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var locationSearch = location || undefined; // Important to be undefined

  var rooms = fields.rooms.length > 0 && fields.rooms[0] !== 'all' ?
  fields.rooms.sort().map(function (item) {return +item;}) : null;

  var types = fields.propertyTypes.length > 0 && fields.propertyTypes[0] !== 'all' ?
  fields.propertyTypes : null;

  var status = fields.status && fields.status.length > 0 && fields.status[0] !== 'all' ?
  fields.status : null;

  var price = {
    minPrice: fields.minPrice ? (0, _clearNumber2.default)(fields.minPrice) : null,
    maxPrice: fields.maxPrice ? (0, _clearNumber2.default)(fields.maxPrice) : null };


  var routeData = Object.assign({},
  routeParams, {
    firstLoad: true,
    location: routeParams.location && !routeParams.location.includes('404') ? routeParams.location : fields.section },
  locationSearch ? { locationSearch: locationSearch } : {}, {
    optionType: fields.optionType,
    favorites: false,
    params: Object.assign({},
    routeParams && routeParams.params || {}, {
      price: price,
      rooms: rooms,
      types: types,
      status: status }) });



  routeData.drawnPoly = (0, _get2.default)(routeData, 'locationSearch.isCity') ? null : routeParams.drawnPoly;

  var advancedRouteData = fields.advancedFilters ?
  (0, _advancedFiltersSearchRequest2.default)(routeData, fields.advancedFilters) :
  routeData;

  var route = (0, _routerAdapter.createUrl)(advancedRouteData);

  if (!routeParams.route || route !== routeParams.route) {
    _reactRouter.browserHistory.push({ pathname: (0, _routerAdapter.deleteLocation)(route), state: advancedRouteData });
  }
}; // Helpers
// Modules
exports.default = sendSearchRequest;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/sendSearchRequest.js
// module id = 1263
// module chunks = 0